/**
 * Local testing of KIT writes. KIT answers browsers only on kitagency.co, so on
 * localhost a lead, a freebie request or a referral click is blocked (CORS) and
 * nothing reaches KIT. In development only, those JSON calls go through our own
 * /api/dev-kit route instead, which forwards them server-side. The route does
 * not exist in production builds, and production never uses this path.
 *
 * Calls made this way are REAL: a test lead is a real lead in KIT.
 */
export function devProxyPath(path: string): string | null {
  if (process.env.NODE_ENV === 'production' || typeof window === 'undefined') return null;
  const h = window.location.hostname;
  if (h === 'kitagency.co' || h.endsWith('.kitagency.co')) return null;
  return `/api/dev-kit?path=${encodeURIComponent(path)}`;
}
